import { getPersonalAI } from "../../API/index";
const INITIATE_PRIVY_LOGIN = 'INITIATE_PRIVY_LOGIN';
const PRIVY_LOGIN_SUCCESS = 'PRIVY_LOGIN_SUCCESS';
const PRIVY_LOGIN_FAILURE = 'PRIVY_LOGIN_FAILURE';

// Action Types
export const SET_PRIVY_USER = 'SET_PRIVY_USER';
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const LOGOUT_PRIVY_USER = 'LOGOUT_PRIVY_USER';
export const SETADDRESS = 'SETADDRESS';
export const SET_API_KEY = 'SET_API_KEY';

// PersonalAI Action Types
export const SET_PERSONAL_AI = 'SET_PERSONAL_AI';
export const REQUEST_PERSONAL_AI = 'REQUEST_PERSONAL_AI';
export const PERSONAL_AI_ERROR = 'PERSONAL_AI_ERROR';

// Action Creators
export const setPrivyUser = (user) => ({
  type: SET_PRIVY_USER,
  payload: user,
});

export const setAuthenticated = (isAuthenticated) => ({
  type: SET_AUTHENTICATED,
  payload: isAuthenticated,
});

export const logoutPrivyUser = () => ({
  type: LOGOUT_PRIVY_USER,
});

export const setApiKey = (apiKey) => ({
  type: SET_API_KEY,
  payload: apiKey,
});

// PersonalAI Action Creators
export const setPersonalAI = (data) => ({
  type: SET_PERSONAL_AI,
  payload: data,
});

export const requestPersonalAI = () => ({
  type: REQUEST_PERSONAL_AI,
});

export const personalAIError = (error) => ({
  type: PERSONAL_AI_ERROR,
  payload: error,
});

// Async action creator for fetching PersonalAI data
export const fetchPersonalAI = (data) => async (dispatch) => {
  try {
    dispatch(requestPersonalAI());
    if (data) {
      const response = await getPersonalAI(data);
      // dispatch(setPersonalAI(response));
      // 如果有data参数，触发更新操作
      dispatch({
        type: 'UPDATE_PERSONAL_AI',
        payload: data
      });
    } else {
      const response = await getPersonalAI();
      dispatch(setPersonalAI(response));
    }
  } catch (error) {
    dispatch(personalAIError(error));
  }
};

